import { extendTheme, theme } from '@chakra-ui/react';

const colors = {
    orange: {
        50: '#FFFAF0',
        100: '#FEEBC8',
        200: '#FBD38D',
        300: '#F6AD55',
        400: '#F29B46',
        500: '#ED8936',
        600: '#DD6B20',
        700: '#C05621',
        800: '#9C4221',
        900: '#7B341E'
    },
    ecp: {
        50: theme.colors.facebook['50'],
        200: theme.colors.facebook['200'],
        100: theme.colors.facebook['100'],
        300: theme.colors.facebook['300'],
        400: theme.colors.facebook['400'],
        500: theme.colors.facebook['500'],
        600: theme.colors.facebook['600'],
        700: theme.colors.facebook['700'],
        800: theme.colors.facebook['800'],
        900: theme.colors.facebook['900']
    },
    warning: theme.colors.yellow['400'],
    danger: theme.colors.red['400'],
    success: theme.colors.green['400'],
    disabled: theme.colors.gray['400'],
    focusBorderColor: theme.colors.blue['500'],
    defaultBorderColor: theme.colors.facebook['200'],
    disconnectedAfterPowerLoss: '#F77076'
    // defaultBorderColor: theme.colors.gray['200']
};

const fonts = {
    heading:
        'Menlo, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
};

const sizes = {
    containers: {
        ...theme.breakpoints,
        '2xl': '1440px',
        xxl: '1440px'
    }
};

export const customTheme = extendTheme( {
    ...theme,
    fonts,
    colors,
    sizes
});